import { ENTITY_LABELS } from "../../../utils/labelMapping";
import React from "react";
import "./PDFLayout.css";

const MetricContentPDFLayout = ({
  entityName,
  category,
  persona,
  location,
  market,
  llm,
  focusAreas,
  tableData,
  filterKeys,
}) => {
  // Helper function to get section title
  const getSectionTitle = (key) => {
    const titleMap = {
      reach: "Visibility",
      visibility: "Visibility",
      positiveSentimentDrivers: "Positive Sentiment Drivers",
      sentimentDrivers: "Negative Sentiment Drivers",
      positiveAttributes: "Positive Attributes",
      negativeAttributes: "Negative Attributes",
      purchaseCriteria: ENTITY_LABELS.PurchaseCriteria,
      productDimensions: "Product Dimensions",
      brandPillars: `${ENTITY_LABELS.Brand} Pillars`,
    };
    return titleMap[key] || key;
  };

  return (
    <div className="metric-pdf-container">
      {/* Header Section */}
      <div className="pdf-header">
        <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
          <img src="/menu.png" width={26} height={26} alt="logo" />
          <h2 style={{ margin: "0 0 0 10px" }}>Brand Luminaire - Content Mapping Report</h2>
        </div>
        <p style={{ margin: "0", color: "#666", fontSize: "12px" }}>
          <b>Generated:</b> {new Date().toLocaleString()}
        </p>
      </div>

      {/* Section 1: Configuration Details */}
      <div className="pdf-section">
        <h3 className="section-title">Configuration Details</h3>
        <div className="config-grid">
          {entityName && (
            <div className="config-item">
              <p className="config-label">Brand/Product Name:</p>
              <p className="config-value">{entityName}</p>
            </div>
          )}
          {category && (
            <div className="config-item">
              <p className="config-label">Category:</p>
              <p className="config-value">{category}</p>
            </div>
          )}
          {persona && (
            <div className="config-item">
              <p className="config-label">Persona:</p>
              <p className="config-value">{persona}</p>
            </div>
          )}
          {location && (
            <div className="config-item">
              <p className="config-label">Location:</p>
              <p className="config-value">{location}</p>
            </div>
          )}
          {market && (
            <div className="config-item">
              <p className="config-label">Market:</p>
              <p className="config-value">{market}</p>
            </div>
          )}
          {llm && (
            <div className="config-item">
              <p className="config-label">LLM:</p>
              <p className="config-value">{llm}</p>
            </div>
          )}
        </div>
      </div>

      {/* Section 2: Focus Areas */}
      {focusAreas && Object.keys(focusAreas).length > 0 && (
        <div className="pdf-section">
          <h3 className="section-title">Optimization Focus Area Identification</h3>
          <div className="focus-areas-content">
            {Object.entries(focusAreas).map(([key, items]) => {
              // Filter out empty or non-array items
              if (!Array.isArray(items) || items.length === 0) {
                return null;
              }

              // Only show selected items (items with selected=true)
              const selectedItems = items.filter((item) => item?.selected === true);
              if (selectedItems.length === 0) {
                return null;
              }

              return (
                <div key={key} className="focus-area-group">
                  <h4 className="focus-area-title">{getSectionTitle(key)}</h4>
                  <div className="focus-area-items">
                    {selectedItems.map((item, idx) => {
                      // Handle different item types
                      let displayName = "";
                      let displayScore = null;

                      if (typeof item === "string") {
                        displayName = item;
                      } else if (item?.name) {
                        displayName = item.name;
                        displayScore = item.score;
                      } else if (item?.text) {
                        displayName = item.text;
                      } else if (typeof item === "object") {
                        displayName = JSON.stringify(item);
                      }

                      return (
                        <div key={idx} className="focus-area-item">
                          <p className="item-name">• {displayName}</p>
                          {displayScore && (
                            <p className="item-score">Score: {Number(displayScore).toFixed(2)}</p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Section 3: Content Suggestions Table */}
      {tableData && tableData.length > 0 && (
        <div className="pdf-section">
          {/* <h3 className="section-title">Content Suggestions</h3> */}
          <div className="table-wrapper">
            <table className="content-table">
              <thead style={{ backgroundColor: "#4fd1c5" }}>
                <tr>
                  <th style={{ color: "#fff", backgroundColor: "#4fd1c5" }}>Focus Area</th>
                  <th style={{ color: "#fff", backgroundColor: "#4fd1c5" }}>Major Discussion Topic</th>
                  <th style={{ color: "#fff", backgroundColor: "#4fd1c5" }}>Subtopic/Angle</th>
                  <th style={{ color: "#fff", backgroundColor: "#4fd1c5" }}>Content Opportunity (Format)</th>
                  <th style={{ color: "#fff", backgroundColor: "#4fd1c5" }}>Proposed Channels</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, rowIdx) => (
                  <tr key={rowIdx} style={{ backgroundColor: rowIdx % 2 === 0 ? "#f5f5f5" : "#ffffff" }}>
                    <td>{row?.theme || "-"}</td>
                    <td>{row?.majorTopic || "-"}</td>
                    <td>{row?.subtopicAngle || "-"}</td>
                    <td>{row?.format || "-"}</td>
                    <td>{row?.channel || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default MetricContentPDFLayout;
